module.exports = {
  standardleadTimeConfig: {
    2: [
      {
        min: 0,
        max: 1,
        value: 9
      },
      {
        min: 1,
        max: 3,
        value: 10
      },
      {
        min: 3,
        max: 5,
        value: 11
      },
      {
        min: 5,
        max: 10,
        value: 14
      },
      {
        min: 10,
        max: null,
        value: 14
      }
    ],
    4: [
      {
        min: 0,
        max: 1,
        value: 9
      },
      {
        min: 1,
        max: 3,
        value: 11
      },
      {
        min: 3,
        max: 5,
        value: 12
      },
      {
        min: 5,
        max: 10,
        value: 16
      },
      {
        min: 10,
        max: null,
        value: 16
      }
    ],
    6: [
      {
        min: 0,
        max: 1,
        value: 10
      },
      {
        min: 1,
        max: 3,
        value: 11
      },
      {
        min: 3,
        max: 5,
        value: 12
      },
      {
        min: 5,
        max: 10,
        value: 16
      },
      {
        min: 10,
        max: null,
        value: 16
      }
    ],
    8: [
      {
        min: 0,
        max: 1,
        value: 12
      },
      {
        min: 1,
        max: 3,
        value: 12
      },
      {
        min: 3,
        max: 5,
        value: 12
      },
      {
        min: 5,
        max: 10,
        value: 16
      },
      {
        min: 10,
        max: null,
        value: 16
      }
    ]
  },
  totalDimensionConfig: {
    2: [
      {
        min: 0,
        max: 1,
        value: 0.15
      },
      {
        min: 1,
        max: 3,
        value: 0.11
      },
      {
        min: 5,
        max: 10,
        value: 0.085
      },
      {
        min: 10,
        max: 20,
        value: 0.08
      },
      {
        min: 20,
        max: null,
        value: 0.07
      }
    ],
    4: [
      {
        min: 0,
        max: 1,
        value: 0.23
      },
      {
        min: 1,
        max: 3,
        value: 0.18
      },
      {
        min: 3,
        max: 10,
        value: 0.145
      },
      {
        min: 10,
        max: null,
        value: 0.13
      }
    ],
    6: [
      {
        min: 0,
        max: 1,
        value: 0.41
      },
      {
        min: 1,
        max: 3,
        value: 0.33
      },
      {
        min: 3,
        max: 10,
        value: 0.26
      },
      {
        min: 10,
        max: null,
        value: 0.23
      }
    ],
    8: [
      {
        min: 0,
        max: 1,
        value: 0.51
      },
      {
        min: 1,
        max: 3,
        value: 0.43
      },
      {
        min: 3,
        max: 5,
        value: 0.37
      },
      {
        min: 5,
        max: null,
        value: 0.34
      }
    ]
  },
  constructionFeeConfig: {
    2: 700,
    4: 1200,
    6: 1600,
    8: 2100
  },
  pcbMaterialCostConfig: {
    'FR-4(TG 130)': 1,
    'FR-4(TG 170)': 1.2
  },
  testStandFeeConfig: {
    2: [
      {
        min: 3,
        max: null,
        value: 2000
      }
    ],
    4: [
      {
        min: 3,
        max: null,
        value: 2500
      }
    ],
    6: [
      {
        min: 3,
        max: null,
        value: 3500
      }
    ],
    8: [
      {
        min: 3,
        max: null,
        value: 4500
      }
    ]
  },
  impedanceTestMultiplierConfig: {
    'yes': 1.11,
    'no': 1
  },
  urgencyConfig: {
    1: 1.3,
    2: 1.5,
    3: 2
  },
  projectCost: [
    {
      min: 0,
      max: 3,
      value: 3300
    },
    {
      min: 3,
      value: 6600
    }
  ],
  immersionFee: 0.022,
  proofingFee: 200.00,
  margin: 0.2,
  serviceFee: 0
}
